


























































import { PinResetMixin } from '@/mixins/pinResetMixin'

export default PinResetMixin.extend({
  name: 'ResetPin',

  data: () => ({
    appId: 0,
    tempToken: '',
    dialog: {
      show: false,
      title: 'Yettel',
      message: 'Desila se greška. Pokušajte ponovo.',
      button: 'U redu'
    }
  }),

  mounted () {
    this.tempToken = this.$route.params.tempToken
  },

  methods: {
    doResetPin (): void {
      this.resetPin(this.tempToken)
        .then(res => {
          if (res.data.data.success) {
            this.appId = this.getResetPinAppIdFromStorage()

            switch (this.appId) {
              case 1:
                window.location.href = 'http://www.ytl.rs/ya'
                break
              case 2:
                this.$router.push({ name: 'Home' }).catch(() => { /* Do nothing */ })
                window.location.reload()
                break
              default:
                this.$router.push({ name: 'Home' }).catch(() => { /* Do nothing */ })
                window.location.reload()
            }
          } else {
            this.dialog.show = true
          }
        })
        .catch(() => {
          this.dialog.show = true
        })
    }
  }
})
